webpackJsonpUpdateBris([74],{

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.SearchResultsPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _validate = __webpack_require__(149);

var _validate2 = _interopRequireDefault(_validate);

var _utils = __webpack_require__(4);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// CONSTANTS are all caps.
var NS = 'SearchResultsPage';
var CLS = 'searchResultsPage';
var PG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadPg.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

var SearchResultsPage = exports.SearchResultsPage = function () {
	function SearchResultsPage($el) {
		_classCallCheck(this, SearchResultsPage);

		// $el is the page node return by the loadSearchResultsPage function
		this.$el = $el;
	}

	_createClass(SearchResultsPage, [{
		key: 'init',
		value: function init() {
			this.setSearchResultsPage();
			this.initFormValidationConstraints();
		}
	}, {
		key: 'setSearchResultsPage',
		value: function setSearchResultsPage() {
			// Add Some logic here
		}
	}, {
		key: 'initFormValidationConstraints',
		value: function initFormValidationConstraints() {
			// the page has only one form
			var This = this;
			var $form = $(this.$el).find('form')[0];
			utils.formValidation($form, This);
		}
	}, {
		key: 'formSuccessCallback',
		value: function formSuccessCallback(form) {
			// check if (same as billing) checkbox is ticked
			$(form).submit();
		}

		// Add more functions like on above here

	}]);

	return SearchResultsPage;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ })

});


// WEBPACK FOOTER //
// 1742452116000.pg-search-results-page-chunk.js